import {apiUrl} from "../definitions";

export default async function fetchPipelines(fetch){
    const requestOptions = {
        method: 'GET',
    };
    return await fetch(`${apiUrl}/fms/pipelines`, requestOptions);
}
